import Vue from 'vue'
// vee validate
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate'

// eslint-disable-next-line camelcase
import { confirmed, min, alpha_num, email, numeric, digits } from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'

localize('ja', ja)

extend('email', {
  ...email
})

extend('min', {
  ...min,
  message: '{_field_}は{length}文字以上で入力してください。'
})

extend('alpha_num', {
  // eslint-disable-next-line camelcase
  ...alpha_num,
  message: '正しい形式で入力してください。'
})

extend('half_alphabet', {
  validate (value) {
    return /(^[a-zA-Z0-9!-/:-@¥[-`{-~]*$)/.test(value)
  },
  message: '不正な形式になっています。'
})

extend('numeric', {
  // eslint-disable-next-line camelcase
  ...numeric
})

extend('digits', {
  // eslint-disable-next-line camelcase
  ...digits
})

extend('required', {
  validate (value) {
    return {
      required: true,
      valid: ['', null, undefined].indexOf(value) === -1
    }
  },
  computesRequired: true,
  message: '{_field_}は必須項目です。'
})

extend('minmax', {
  validate (value, { min, max }) {
    return value.length >= min && value.length <= max
  },
  params: ['min', 'max'],
  message: '{_field_}は{min}文字から{max}文字まで入力してください。'
})

extend('confirmed', {
  ...confirmed,
  message: 'パスワードが一致しません。'
})

extend('max', {
  validate (value, { length }) {
    return value.length <= length
  },
  params: ['length'],
  message: '{_field_}は{length}文字以内で入力してください。'
})

extend('format_tel', {
  validate (value) {
    return /(^0\d{9,10}$)/.test(value)
  },
  message: '{_field_}のフォーマットが正しくありません。'
})
extend('zipcode', {
  validate: (value) => {
    return /(^\d{7}$)/.test(value)
  },
  message: '{_field_}は半角数字のみです。'
})

extend('not_emoji', {
  validate (value) {
    let regexEmoji = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug
    return !regexEmoji.test(value)
  },
  message: '使用できない文字が入力されています。'
})

extend('katakana', {
  validate (value) {
    const regex = new RegExp('^([ァ-ヴ]|ー|-)+$')
    return regex.test(value)
  },
  message: '{_field_}は全角カタカナで入力してください。'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)



// WEBPACK FOOTER //
// ./src/utils/customizeValidate.js